/** Get the default gradients we use */

import type { DesignTokens } from '@tunasong/ui-lib'
import type { ColorStop } from './wave-canvas-draw.js'

interface GetWaveGradient {
  type?: 'audio' | 'monitor'
  tokens: DesignTokens
}

export const getWaveGradient = ({ tokens, type = 'audio' }: GetWaveGradient): ColorStop[] => {
  if (type === 'audio') {
    return [
      [0, tokens.palette.primary.dark],
      [0.5, tokens.palette.primary.light],
      [1, tokens.palette.primary.dark],
    ]
  }
  if (type === 'monitor') {
    return [
      [0, tokens.palette.warning.dark],
      [0.5, tokens.palette.text.primary],
      [1, tokens.palette.warning.dark],
    ]
  }
  throw new Error(`Unknown wave type: ${type}`)
}
